<template>
<ScreenLayout>
    <div slot="left" class="white-background" style="position:relative;display:flex;flex-direction:column;height:100%">
  
        <!-- List -->
        <ListList :items="items" v-model="item" />

        <div style="position:absolute;right:5px;bottom:10px;width:60px;">
            <v-btn @click="add" right fab color="primary">
                <v-icon dark large>mdi-plus</v-icon>
            </v-btn>
        </div>
       
    </div>

    <!-- Form -->

    <div v-if="item" class="pa-10 white ma-7 elevation-3" style="position:relative;xbackground-color:rgba(0,0,0,0.0)">
        <ConfirmIcon corner @click="deleteCurrent()"/>
        <FormControl ref="itemForm" :schema="proofSchema" v-model="item" />
    </div>

    <div slot="right">
        
    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import Db from '@/data/Db'
import Db1 from '@/data/Db1'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import ListList from '@/forms/lists/ListList'
import RouterHelpers from '@/helpers/RouterHelpers'
import FormControl from '../forms/FormControl'

export default {
    name: 'Maintenance',
    props: {
        i: String, //id of selected item
    },
    components: {
        ScreenLayout, ConfirmIcon, ListList, FormControl
    },
    data() {
        return {
            // selectedIndex: null,
            item: null,
            proofsDoc: null,

            proofSchema:{
                fields: [ 
                {
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    validation: 'required',
                },
                {
                    type: 'text',
                    name: 'keywords',
                    label: 'Other Search Keywords',
                },
                {
                    type: 'file',
                    name: 'sample',
                    label: 'Sample Version',
                    multiple: true, 
                    path: 'apps/dc/lists/items'
                },
                {
                    type: 'group',
                    name: 'checks',
                    label: 'Document Checks',
                    columns: false,
                    fields: [
                        {
                            type: 'text',
                            name: 'title',
                            label: 'Title',
                            placeholder: ' ',
                            hint: 'What to check...',
                            validation: 'required',
                        },
                        {
                            type: 'text',
                            name: 'description',
                            label: 'Description',
                            hint: 'How to check it...',
                            validation: 'required',
                        },
                    ]
                }
            ]},

            claimSchema: [ 
                {
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    validation: 'required',
                },
                {
                    type: 'text',
                    name: 'name',
                    label: 'Name',
                    placeholder: 'claim_name',
                    validation: 'fieldname|required',
                },
                {
                    type: 'text',
                    name: 'keywords',
                    label: 'Other Search Keywords',
                },
            ],

            
            
        }
    },
    computed:{

        items() {
            if(!this.proofsDoc)
                return []
            if(!this.proofsDoc.list)
                this.proofsDoc.list = []
            return this.proofsDoc.list
        },

        lists() { 
            return [
                {
                    name: 'Claims',
                    schema: this.claimSchema,
                    path: 'apps/dc/lists/claims',
                },
                {
                    name: 'Proofs',
                    schema: this.proofSchema,
                    path: 'apps/dc/lists/proofs',
                }
            ]
        },
        currentList() {
            return this.lists[1]
        },




    },
    methods: {

        select(item) {
            this.item = item || this.items[0]
            RouterHelpers.setQueryParameter(this, 'i', item._id)
        },

        add() {
            const newItem = {
                _id: Db1.newId(),
                title: 'New Item'
            }
            this.items.unshift(newItem)
            this.select(newItem)
            this.$refs.itemForm.focusFirst()
        },
        save() {
            Db1.saveDocument(this.proofsDoc)
        },

        deleteCurrent() {
            const idx = this.items.findIndex(p => p == this.item)
            this.items.splice(idx, 1)
            this.select()
            this.save()
        }
    },

    created() {    
        Db1.fetchDocumentByCode('apps/dc/lists', 'proofs').then(doc => {
            this.proofsDoc = doc
            this.item = this.items.find(o => o._id == this.i) || this.items[0]
        })
    },

    beforeDestroy() {
        this.save()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Maintenance.vue?266441db